module.exports = __webpack_public_path__ + "img/5.3f25d0de.png";